var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateIconMagenta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4363_38213",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4363_38213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54813 14.5846C7.17299 14.5846 6.8559 14.4551 6.59687 14.1961C6.33785 13.9371 6.20833 13.62 6.20833 13.2448V3.75776C6.20833 3.38262 6.33785 3.06554 6.59687 2.80651C6.8559 2.54748 7.17299 2.41797 7.54813 2.41797H15.0352C15.4103 2.41797 15.7274 2.54748 15.9865 2.80651C16.2455 3.06554 16.375 3.38262 16.375 3.75776V13.2448C16.375 13.62 16.2455 13.9371 15.9865 14.1961C15.7274 14.4551 15.4103 14.5846 15.0352 14.5846H7.54813ZM7.54813 13.5013H15.0352C15.0994 13.5013 15.1581 13.4746 15.2115 13.4211C15.2649 13.3678 15.2917 13.309 15.2917 13.2448V3.75776C15.2917 3.69359 15.2649 3.63484 15.2115 3.58151C15.1581 3.52804 15.0994 3.5013 15.0352 3.5013H7.54813C7.48396 3.5013 7.42521 3.52804 7.37188 3.58151C7.3184 3.63484 7.29167 3.69359 7.29167 3.75776V13.2448C7.29167 13.309 7.3184 13.3678 7.37188 13.4211C7.42521 13.4746 7.48396 13.5013 7.54813 13.5013ZM4.96479 17.168C4.58965 17.168 4.27257 17.0385 4.01354 16.7794C3.75451 16.5204 3.625 16.2033 3.625 15.8282V5.79943C3.625 5.64568 3.67646 5.51693 3.77938 5.41318C3.88215 5.30957 4.00979 5.25776 4.16229 5.25776C4.31479 5.25776 4.44396 5.30957 4.54979 5.41318C4.65549 5.51693 4.70833 5.64568 4.70833 5.79943V15.8282C4.70833 15.8923 4.73507 15.9511 4.78854 16.0044C4.84188 16.0579 4.90062 16.0846 4.96479 16.0846H12.9935C13.1473 16.0846 13.276 16.136 13.3798 16.2388C13.4834 16.3417 13.5352 16.4694 13.5352 16.6219C13.5352 16.7744 13.4834 16.9035 13.3798 17.0092C13.276 17.1151 13.1473 17.168 12.9935 17.168H4.96479Z",
    fill: "#E70070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIconMagenta);
export default __webpack_public_path__ + "static/media/duplicate-icon-magenta.f263355425cb28b80836296fc73ba122.svg";
export { ForwardRef as ReactComponent };